import { Locker, Calculator } from './';

export default {
  path: 'locker',
  childRoutes: [

    { path: '', component: Locker, isIndex: true }
  ]
};